import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import type { FAQ } from '../data/salesPageData';
type FAQAccordionProps = {
  items: FAQ[];
};
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="mx-auto max-w-3xl divide-y divide-[#dcd4c6] border-y border-[#dcd4c6]" data-id="element-1">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      const panelId = `faq-panel-${index}`;
      return <div key={item.question} data-id="element-2">
            <h3 data-id="element-3">
              <button type="button" className="flex w-full items-center justify-between gap-5 py-5 text-left text-base font-bold text-[#29291f] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#a95848] focus-visible:ring-offset-2" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-4">
                <span data-id="element-5">{item.question}</span>
                <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-[#a95848] transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-6" />
              </button>
            </h3>
            <div id={panelId} hidden={!isOpen} className="max-w-2xl pb-5 pr-10 text-sm leading-6 text-[#65665b]" data-id="element-7">
              {item.answer}
            </div>
          </div>;
    })}
    </div>;
}